import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_COMPONENT_REVIEW = registerFeatureWithDescription({
    numericalId: 408,
    id: "component-review",
    name: "Component Review",
    internalUseOnly: true,
    descriptionLines: ["Allows the reviewing of components created in Component Library."],
})
